import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = i((e, r) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: r,
    ...e,
    image: (l) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM16.284 20h-1.84v-3.521h-3.217v3.52h-1.84v-8.401h1.84v3.334h3.217v-3.334h1.84zm6.797-2.379c-.129 1.676-1.289 2.549-2.877 2.549-1.804 0-2.994-1.16-2.994-3.235 0-2.068 1.225-3.287 3.006-3.287 1.611 0 2.766.868 2.865 2.538h-1.816c-.035-.791-.428-1.178-1.026-1.178-.726 0-1.2.597-1.2 1.892 0 1.301.45 1.91 1.195 1.91.568 0 .978-.374 1.03-1.189z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "HydrocortisoneIcon";
export {
  t as HydrocortisoneIcon,
  t as default
};
//# sourceMappingURL=index.js.map
